var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CalcCostDocument,{attrs:{"variant":"dialog","calcData":_setup.calcData,"totalPrice":_setup.basicInfo?.totalPrice,"editable":false,"paperCalcCostClass":"cost_table_border print_cost_table"}})
}
var staticRenderFns = []

export { render, staticRenderFns }